import { getObjectKeysAsObject } from "@checkout/helpers";
import { fetchTripPricingService } from "./fetchTripPricing";

export const services = {
  fetchTripPricingService,
};

export const ServiceTypes = getObjectKeysAsObject(services);
